export class TrancheReductionMl {
  start: Number;
  quantityAllowed: Number;

  constructor() {
    this.start = 0;
    this.quantityAllowed = 3;
  }
}
